import type { LayoutChangeEvent, LayoutRectangle } from 'react-native';

import { useEffect, useState } from 'react';

declare global {
    interface GlobalEventHandlersEventMap {
        maincontentlayout: MainContentLayoutEvent;
    }
}

// Publishes the dimensions of the main content element on web. We need this
// because react-navigation uses absolute positioning for its screens, which removes
// content from the document flow and breaks layout with elements that aren't part
// of the react-navigation screen (e.g. GNav header and footer). This can be used
// to explicitly set the height of the React root
export function handleMainContentLayout(layoutEvent: LayoutChangeEvent): void {
    window.dispatchEvent(new MainContentLayoutEvent(layoutEvent.nativeEvent.layout));
}

export function useMainContentLayout(): LayoutRectangle | null {
    const [layout, setLayout] = useState<LayoutRectangle | null>(null);
    useEffect(() => {
        window.addEventListener('maincontentlayout', (layoutEvent: MainContentLayoutEvent) => {
            setLayout(layoutEvent);
        });
    }, [setLayout]);

    return layout;
}

class MainContentLayoutEvent extends Event implements LayoutRectangle {
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(layout: LayoutRectangle) {
        super('maincontentlayout', { bubbles: true, composed: true });
        this.x = layout.x;
        this.y = layout.y;
        this.height = layout.height;
        this.width = layout.width;
    }
}
